import { notificationMessages } from "helpers/constantMessages";
import { useCompanyProfileStore } from "hooks/CompanyProfile";
import { useLoginStore } from "hooks/Login";
import { useEffect, useState } from "react";
import { FaCommentSms, FaEnvelope } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io5";
import { CustomInput, FormGroup, Input, Label } from "reactstrap";
import Select from "react-select";
import moment from "moment-timezone";
import Common from "helpers/Common";

const CustomerSettings = ({ taxDetails, getGenricData }) => {
  const [{}, { getTimeZone }, { saveCustomerEnableServicesDetails }] =
    useCompanyProfileStore();
  const [{}, {}, { setAlerts }] = useLoginStore();

  const [emailEnable, setEmailEnable] = useState(false);
  const [smsEnable, setSMSEnable] = useState(false);
  const [whatsappEnable, setWhatsappEnable] = useState(false);
  const [companyTzSelect, setCompanyTzSelect] = useState(null);
  const [userTzSelect, setUserTzSelect] = useState(null);
  const [timezones, setTimezones] = useState([]);

  const getTimezonesWithOffsets = () => {
    const timezonesArray = moment.tz.names(); // Get all timezone names

    // Map through the timezones and calculate their offsets
    return timezonesArray.map((tz) => {
      const offsetInMinutes = moment.tz(tz).utcOffset(); // Get offset in minutes
      const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
      const minutes = Math.abs(offsetInMinutes) % 60;
      const sign = offsetInMinutes >= 0 ? "+" : "-";
      const formattedOffset = `${sign}${String(hours).padStart(
        2,
        "0"
      )}:${String(minutes).padStart(2, "0")}`;

      return {
        value: tz, // Value to be stored
        label: `${tz} (UTC${formattedOffset})`, // Label to be shown in the dropdown
      };
    });
  };

  useEffect(() => {
    const tzList = getTimezonesWithOffsets();
    setTimezones(tzList);
  }, []);

  useEffect(() => {
    try {
      setEmailEnable(
        taxDetails?.filter((data) => data.feature_key == "email_enabled")[0]
          .feature_value == "YES"
          ? true
          : false
      );
      setSMSEnable(
        taxDetails?.filter((data) => data.feature_key == "sms_enabled")[0]
          .feature_value == "YES"
          ? true
          : false
      );
      setWhatsappEnable(
        taxDetails?.filter((data) => data.feature_key == "whatsup_enabled")[0]
          .feature_value == "YES"
          ? true
          : false
      );

      let timeZone = getTimeZone();

      if (timeZone?.companyTimeZone) {
        const offsetInMinutes = moment
          .tz(timeZone?.companyTimeZone)
          .utcOffset(); // Get offset in minutes
        const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
        const minutes = Math.abs(offsetInMinutes) % 60;
        const sign = offsetInMinutes >= 0 ? "+" : "-";
        const formattedOffset = `${sign}${String(hours).padStart(
          2,
          "0"
        )}:${String(minutes).padStart(2, "0")}`;

        setCompanyTzSelect({
          value: timeZone?.companyTimeZone, // Value to be stored
          label: `${timeZone?.companyTimeZone} (UTC${formattedOffset})`,
        });
      }

      if (timeZone?.userTimeZone) {
        const offsetInMinutes = moment.tz(timeZone?.userTimeZone).utcOffset(); // Get offset in minutes
        const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
        const minutes = Math.abs(offsetInMinutes) % 60;
        const sign = offsetInMinutes >= 0 ? "+" : "-";
        const formattedOffset = `${sign}${String(hours).padStart(
          2,
          "0"
        )}:${String(minutes).padStart(2, "0")}`;

        setUserTzSelect({
          value: timeZone?.userTimeZone, // Value to be stored
          label: `${timeZone?.userTimeZone} (UTC${formattedOffset})`,
        });
      }
    } catch (error) {}
  }, [taxDetails]);

  const saveCustomerDetails = async (value, type, isTimezone = false) => {
    if (type == "sms") setSMSEnable((prev) => !prev);
    if (type == "email") setEmailEnable((prev) => !prev);
    if (type == "whatsapp") setWhatsappEnable((prev) => !prev);

    let res = {};
    let param = {
      feature_key:
        type === "sms"
          ? "sms_enabled"
          : type === "email"
          ? "email_enabled"
          : "whatsup_enabled",
      feature_value: value === true ? "YES" : "NO",
    };
    // }
    res = await saveCustomerEnableServicesDetails(param);
    if (res) {
      await getGenricData();
      await setAlerts({
        type: "success",
        message: notificationMessages.customerProfileSettings,
      });
    }
  };

  return (
    <div className="profile-content-container">
      <div className="profile-content-title">
        <h5>Customer Notification Settings</h5>
      </div>

      <FormGroup className="profile-notification-setting-item">
        <FaCommentSms size={25} />

        <Label for="">SMS Enabled</Label>

        <CustomInput
          type="switch"
          id="smsTogBtn"
          onChange={(e) => {
            saveCustomerDetails(e.target.checked, "sms");
          }}
          checked={smsEnable}
        />
      </FormGroup>

      <FormGroup className="profile-notification-setting-item">
        <FaEnvelope size={25} />

        <Label for="">Email Enabled</Label>

        <CustomInput
          type="switch"
          id="emailTogBtn"
          onChange={(e) => {
            saveCustomerDetails(e.target.checked, "email");
          }}
          checked={emailEnable}
        />
      </FormGroup>

      <FormGroup className="profile-notification-setting-item">
        <IoLogoWhatsapp size={25} />

        <Label for="">Whatsapp Enabled</Label>

        <CustomInput
          type="switch"
          id="whatsappTogBtn"
          onChange={(e) => {
            saveCustomerDetails(e.target.checked, "whatsapp");
          }}
          checked={whatsappEnable}
        />
      </FormGroup>
    </div>
  );
};

export default CustomerSettings;
